package tk.mallumo.compose.navigation.viewmodel

abstract class NavigationViewModel : SharedViewModel()
